import { t } from "i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AppLoader from "../../../components/apploader";
import CustomContainer from "../../../components/container/CustomContainer";
import DashboardHeader from "../../../components/dashboardHeader";
import DynamicTable from "../../../components/table";
import { useSnackbar } from "../../../lib/context/snackbarContext";
import { getUserWalletHistory } from "../../../services/walletHistoryFn";
import { Typography } from "@mui/material";

const headerData = ["dateAndTime", "transactionType", "totalAmount"];

const tableRows = ["date_time", "transaction_type", "total_amount", ,];

const WalletHistoryPage = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [walletHistory, setWalletHistory] = useState([]);
  const userData = useSelector((state) => state.userReducer.user);

  useEffect(() => {
    if (userData) {
      fetchAllOrders();
    }
  }, [userData]);

  const fetchAllOrders = async () => {
    try {
      setIsLoading(true);
      const response = await getUserWalletHistory(userData._id);
      if (response?.data.status === "success") {
        let data = response?.data?.data;
        setWalletHistory(data);
      } else {
        showSnackbar(response?.data.message, "error");
      }
    } catch (error) {
      showSnackbar(error?.message, "error");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <DashboardHeader>
      <AppLoader isVisible={isLoading} />
      <CustomContainer
        primaryHeading={t("walletHistory")}
        secondaryHeading={t("viewWalletHistory")}
        showBackButton={true}
        handleBack={() => navigate("/dashboard")}
      >
        <DynamicTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={walletHistory || []}
        />
        {walletHistory.length === 0 && !isLoading && (
          <Typography variant="h6" textAlign={"center"} fontWeight={600} mt={2}>
            {t("noWalletHistoryFound")}
          </Typography>
        )}
      </CustomContainer>
    </DashboardHeader>
  );
};

export default WalletHistoryPage;
